<div>
  <rask-list [data]="documents">
    <rask-list-column [header]="texts.dokument" field="filnamn">
      <ng-template let-row="row">
        @if(!row.inaktiverad){
          <a [attr.href]="row.url" target="_blank">{{ row.filnamn }}</a>
        }
        @else {
        <a class="inactive-link">{{ row.filnamn }}</a>
      }
    </ng-template>
  </rask-list-column>
  <rask-list-column
    [header]="texts.extraInfo"
    field="extraInfo"
  [sortable]="true"></rask-list-column>
  <rask-list-column
    [header]="texts.skapad"
    field="skapadTid"
  [sortable]="true"></rask-list-column>
</rask-list>
@if (hasInactiveDocuments) {
  <div class="my-3 pb-3 ps-4 inactiveinfo">
    <label>
      Inaktiv<rask-info>Inaktiva dokument kan ex. vara dokument som blivit GDPR rensade.</rask-info>
    </label>
  </div>
}
<div class="my-3">
  @if (!isLeveransvirke) {
    <rask-button
      class="mx-3 px-0"
      color="secondary"
      [disabled]="!canCreateAvverkningsdirektiv"
      (click)="createAvverkningsdirektiv()">
      @if (avverkningsdirektivWorking$ | async) {
        <rask-busy-spinner
          size="1"
        ></rask-busy-spinner>
      }
      {{ texts.skapaAvverkningsdirektiv }}
    </rask-button>
    <rask-button
      class="mx-3 px-0"
      color="secondary"
      [disabled]="!canCreateAvverkningsdirektivUtkast"
      (click)="createAvverkningsdirektivUtkast()">
      @if (avverkningsdirektivWorking$ | async) {
        <rask-busy-spinner
          size="1"
        ></rask-busy-spinner>
      }
      Skapa utkast för avverkningsdirektiv
    </rask-button>
    }
</div>
<div>
  <rask-button
    class="mx-3 px-0"
    color="secondary"
    [disabled]="!canCreateApteringspaket"
    (click)="createApteringspaket()">
    @if (apteringspaketWorking$ | async) {
      <rask-busy-spinner
        size="1"
      ></rask-busy-spinner>
    }
    {{ texts.skapaApteringspaket }}
  </rask-button>
  @if (canRecreateSkordare) {
    <rask-checkbox class="col-3 no-label" text="Skördarfiler" [(ngModel)]="recreateSkordare"></rask-checkbox>
  }
  <rask-checkbox class="col-3 no-label" text="Skotarfiler" [(ngModel)]="recreateSkotare"></rask-checkbox>
</div>
</div>
